import { render, staticRenderFns } from "./FileQuestion.vue?vue&type=template&id=61f50f6b&"
import script from "./FileQuestion.vue?vue&type=script&lang=ts&"
export * from "./FileQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports